import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
const EditAccountComponent = loadable(
  () => import("../../components/AccountInfo/EditAccount")
);

const EditAccount = () => {
  const { id } = useParams();
  const {
    data,
    isLoading: isDataLoading,
    refetch,
  } = useGetHook({
    url: `${APIS.COA}${id}/`,
    queryKey: ["account-info", `account-info-${id}`],
    params: {},
  });
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["account-info"],
    navigateURL: "/accounting/account",
  });
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.COA}${id}/`;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Edit Account</h1>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditAccountComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          data={data}
        />
      )}
    </div>
  );
};

export default EditAccount;
